export const addZerosAtStart = (number, length) => {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }

    return my_string;
};

export const formatDateTime = (date) => {
    return date.getDate() + ". " + (date.getMonth() + 1) + ". " + (date.getFullYear()) + " " + date.getHours() + ":" + addZerosAtStart(date.getMinutes(), 2);
};
export const TextfieldDateTime = (date) => {
    return date.getFullYear() + "-" + addZerosAtStart((date.getMonth() + 1), 2) + "-" + addZerosAtStart(date.getDate(), 2) + "T" + addZerosAtStart(date.getHours(), 2) + ":" + addZerosAtStart(date.getMinutes(), 2);
};

export function daysBetween(date1, date2) {

    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);

    // Convert back to days and return
    return Math.ceil(differenceMs / ONE_DAY);

}